module.exports = __webpack_public_path__ + "img/Mega Discount.dbd62c1f.svg";